export default "/assets/167bc14c266de22d.svg"